import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import {
  AnalyticsContext,
  ViewUpgradeEvent,
  UpgradeButtonTapEvent,
} from "../../common/context/AnalyticsContext";
import {
  AppFlowStepContainer,
  AppFlowTitle,
  AppFlowStepContentContainer,
  AppFlowContinueButton,
} from "../../common/CommonStyles";

const UpgradeContentRow = styled.div`
  display: flex;
  gap: 1.5%;
  padding-right: 0;
  padding-left: 0;

  max-width: 460px;
`;

const UpgradeContentImageContainer = styled.div`
  width: 100px;
  min-width: 100px;
  max-width: 100px;
  display: flex;
  align-items: center;
`;

const UpgradeContentText = styled.div`
  display: flex;
  flex-direction: column;

  h5 {
    margin-left: 1.2rem;
  }

  span {
    font-size: 0.9rem;
  }

  ul {
    padding-left: 0;
    margin-left: 1.2rem;
  }
`;

export const Upgrade: React.FC<{ next: () => void }> = ({ next }) => {
  const { t } = useTranslation();
  const { logEvent } = React.useContext(AnalyticsContext);
  const shouldLogViewUpgrade = React.useRef<boolean>(true);

  if (shouldLogViewUpgrade.current) {
    logEvent(new ViewUpgradeEvent("None"));
    shouldLogViewUpgrade.current = false;
  }

  return (
    <AppFlowStepContainer>
      <AppFlowTitle title={t("upgrade_title_text_reason")} />
      <AppFlowStepContentContainer>
        <UpgradeContentRow>
          <UpgradeContentImageContainer>
            <img alt="" className="img-fluid" src={`${process.env.PUBLIC_URL}/upgrade_lessons_grid.png`} />
          </UpgradeContentImageContainer>
          <UpgradeContentText>
            <div>
              <h5>{t("upgrade_courses_title")}</h5>
            </div>
            <div>
              <ul>
                <li>
                  <span>{t("upgrade_courses_text_0")}</span>
                </li>
                <li>
                  <span>{t("upgrade_courses_text_1")}</span>
                </li>
                <li>
                  <span>{t("upgrade_courses_text_2")}</span>
                </li>
                <li>
                  <span>{t("upgrade_courses_text_3")}</span>
                </li>
              </ul>
            </div>
          </UpgradeContentText>
        </UpgradeContentRow>
        <UpgradeContentRow>
          <UpgradeContentImageContainer>
            <img alt="" className="img-fluid" src={`${process.env.PUBLIC_URL}/upgrade_practice.png`} />
          </UpgradeContentImageContainer>
          <UpgradeContentText>
            <div>
              <h5>{t("upgrade_practice_title")}</h5>
            </div>
            <div>
              <ul>
                <li>
                  <span>{t("upgrade_practice_text_0")}</span>
                </li>
                <li>
                  <span>{t("upgrade_practice_text_1")}</span>
                </li>
              </ul>
            </div>
          </UpgradeContentText>
        </UpgradeContentRow>
        <UpgradeContentRow>
          <UpgradeContentImageContainer>
            <img alt="" className="img-fluid" src={`${process.env.PUBLIC_URL}/upgrade_features.png`} />
          </UpgradeContentImageContainer>
          <UpgradeContentText>
            <div>
              <h5>{t("upgrade_features_title")}</h5>
            </div>
            <div>
              <ul>
                <li>
                  <span>{t("upgrade_features_text_0")}</span>
                </li>
                <li>
                  <span>{t("upgrade_features_text_1")}</span>
                </li>
              </ul>
            </div>
          </UpgradeContentText>
        </UpgradeContentRow>
        <div className="d-flex justify-content-center pt-2">
          <AppFlowContinueButton
            text={t("app_flow_continue_button")}
            enabled={true}
            onClick={() => {
              logEvent(new UpgradeButtonTapEvent());
              next();
            }}
          />
        </div>
      </AppFlowStepContentContainer>
    </AppFlowStepContainer>
  );
};
